import React from 'react';
import Paragraph from "@scentregroup/ui/components/paragraph";
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const FulfilmentMethod = _ref => {
  let {
    label,
    cost,
    addendum
  } = _ref;

  if (typeof cost === 'string') {
    return /*#__PURE__*/_jsxs("div", {
      className: style.fulfilmentMethod,
      "data-id": "fulfilment-method_fulfilment-method_FulfilmentMethod_div",
      children: [/*#__PURE__*/_jsxs("div", {
        className: style.titleRow,
        "data-id": "fulfilment-method_fulfilment-method_FulfilmentMethod_div_div_1",
        children: [/*#__PURE__*/_jsx("div", {
          className: style.labelAndSublabel,
          "data-id": "fulfilment-method_fulfilment-method_FulfilmentMethod_div_div_2",
          children: /*#__PURE__*/_jsx(Paragraph, {
            className: style.label,
            "data-id": "fulfilment-method_fulfilment-method_FulfilmentMethod_div_Paragraph",
            children: label
          })
        }), /*#__PURE__*/_jsx(Paragraph, {
          className: style.value,
          "data-id": "fulfilment-method_fulfilment-method_FulfilmentMethod_div_Paragraph_4",
          children: cost
        })]
      }), addendum && /*#__PURE__*/_jsx(Paragraph, {
        "data-id": "fulfilment-method_fulfilment-method_FulfilmentMethod_Paragraph_5",
        children: addendum
      })]
    });
  }

  return /*#__PURE__*/_jsxs("div", {
    className: style.fulfilmentMethod,
    "data-id": "fulfilment-method_fulfilment-method_FulfilmentMethod_div",
    children: [/*#__PURE__*/_jsx("div", {
      className: style.titleRow,
      "data-id": "fulfilment-method_fulfilment-method_FulfilmentMethod_div_div_7",
      children: /*#__PURE__*/_jsx("div", {
        className: style.labelAndSublabel,
        "data-id": "fulfilment-method_fulfilment-method_FulfilmentMethod_div_div_8",
        children: /*#__PURE__*/_jsx(Paragraph, {
          className: style.label,
          "data-id": "fulfilment-method_fulfilment-method_FulfilmentMethod_div_Paragraph",
          children: label
        })
      })
    }), cost.map((_ref2, i) => {
      let {
        label,
        cost
      } = _ref2;
      return /*#__PURE__*/_jsxs("div", {
        className: style.costRow,
        "data-id": "fulfilment-method_fulfilment-method_FulfilmentMethod_div",
        children: [/*#__PURE__*/_jsx(Paragraph, {
          className: style.label,
          "data-id": "fulfilment-method_fulfilment-method_FulfilmentMethod_div_Paragraph",
          children: label
        }), /*#__PURE__*/_jsx(Paragraph, {
          className: style.value,
          "data-id": "fulfilment-method_fulfilment-method_FulfilmentMethod_div_Paragraph_12",
          children: cost
        })]
      }, "".concat(i, " - ").concat(label));
    }), addendum && /*#__PURE__*/_jsx(Paragraph, {
      "data-id": "fulfilment-method_fulfilment-method_FulfilmentMethod_Paragraph_13",
      children: addendum
    })]
  });
};

export default FulfilmentMethod;